import { render, staticRenderFns } from "./RecibosEsam.vue?vue&type=template&id=5aa165b3"
import script from "./RecibosEsam.vue?vue&type=script&lang=js"
export * from "./RecibosEsam.vue?vue&type=script&lang=js"
import style0 from "./RecibosEsam.vue?vue&type=style&index=0&id=5aa165b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports